<template>
  <div class="filter-wrap">
    <div class="filter-body-wrap">
      <div class="second-filter-wrap">
        <FilterTitle title="二次检索" optText="清空" @clear="clearSecond"></FilterTitle>
        <a-input-search class="search-wrap" v-model="secondSearchValue" placeholder="回车确认检索" allowClear pressEnter @search="onSearch" />
      </div>
      <div class="filter-item-wrap">
        <FilterTitle title="筛选项" optText="重置" @clear="initFilterListStatus"></FilterTitle>
        <FilterItemCard type="filter" v-on="$listeners"></FilterItemCard>
        <FilterItemCard type="exclude" v-on="$listeners"></FilterItemCard>
        <BaseGroup
          ref="baseGroup"
          :config="filterItemConfig"
          v-bind="$attrs"
          :searchParams="searchParams"
          :sideCode="sideCode"
          v-on="$listeners"
          @ipcTabChange="handlerUpdateIpc"
          @updateIndex="handlerUpdateIndex"
          @loadMore="_loadMoreFilterGroup"
          @putAway="handlerPutAway">
        </BaseGroup>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import FilterTitle from '../common/FilterTitle.vue'
import BaseGroup from './BaseGroup.vue'
import FilterItemCard from './FilterItemCard.vue'
import mixinFilterOperation from './mixins/index'

export default {
  mixins: [mixinFilterOperation],
  props: {
    searchParams: Object,
    filterItemConfig: Array, // 配置
    sideCode: Object
  },
  data() {
    return {
      // filterItemConfig, // 侧边栏过滤配置
      secondSearchValue: '' // 二筛结果
    }
  },
  components: {
    FilterTitle,
    BaseGroup,
    FilterItemCard
  },
  computed: {
    ...mapGetters('filterGroup', [
      'getSecondSearchExp'
    ])
  },
  created() {
    this.initSetting()
  },
  methods: {
    ...mapMutations('filterGroup', [
      'updateSecondSearchExp',
      'clearSecondSearchExp'
    ]),
    initSetting() {
      this.secondSearchValue = this.getSecondSearchExp
    },
    clearSecond() {
      this.secondSearchValue = ''
      this.clearSecondSearchExp()
    },
    onSearch(v) {
      this.secondSearchValue = v
      const exp = v ? `SS=(${v})` : ''
      this.updateSecondSearchExp(exp)
    },
    // 重置侧边栏
    initFilterListStatus() {
      this.$emit('resetSideMenu')
    },
    // 标题的选项切换
    handlerUpdateIndex(params) {
      const { item, index } = params
      item.currentIndex = index
      const { name, currentIndex, isV2percent } = item
      if (isV2percent) {
        return this.toTransitionV2Percent(item)
      }
      this.spliceTarget(name[currentIndex]) // 清空已经调用接口数组中的名字存储存储
      this._getFilterGroup(item, 'switch')
    },
    // tabs切换
    handlerUpdateIpc(params) {
      const { item, tab } = params
      item.key = tab // 把key设置成当前选中的tab
      this._getFilterGroup(item, 'ipc')
    }
  }
}
</script>
